import get from 'lodash/get';
import camelCase from 'lodash/camelCase';
import {ITranslate} from '../../services/LocalizationService';
import {BrowserInfo, BrowserNotSupportedState} from './browser-not-supported.state';

function extractBrowsers(browsers: any): string[] {
    const enabledBrowsersArr: string[] = [];

    if (browsers.enabledChrome) {
        enabledBrowsersArr.push('Chrome');
    }

    if (browsers.enabledFF) {
        enabledBrowsersArr.push('Firefox');
    }

    if (browsers.enabledIE) {
        enabledBrowsersArr.push('IE');
    }

    if (browsers.enabledSafari) {
        enabledBrowsersArr.push('Safari');
    }

    if (browsers.enabledMobileSafari) {
        enabledBrowsersArr.push('Mobile Safari');
    }

    if (browsers.enabledEdge) {
        enabledBrowsersArr.push('Edge');
    }

    if (browsers.enabledChromeWebview) {
        enabledBrowsersArr.push('Chrome Webview');
    }

    if (browsers.enabledChromeForAndroid) {
        enabledBrowsersArr.push('Chrome for Android');
    }

    if (browsers.enabledChromeForIos) {
        enabledBrowsersArr.push('Chrome for iOS');
    }

    return enabledBrowsersArr;
}

export interface IBrowserNotSupportedController {
    readonly translate: ITranslate;
    readonly dir: string;
    readonly browserInfo: BrowserInfo | null;
    readonly userName: string;
    readonly browserMajor: string;
    readonly enabledBrowsersArr: string[];
    readonly enabledBrowsers: string;
    readonly minVersion: string | undefined;
    readonly excludedVersions: string | undefined;
    readonly browserIcons: string[];
}

export class BrowserNotSupportedController implements IBrowserNotSupportedController {
    readonly dir: string;
    private readonly _translate: ITranslate;
    private readonly _environmentService: any;
    private readonly _displayTabletAsDesktop: boolean;

    enabledBrowsersArr: string[] = [];
    enabledBrowsers: string = '';
    minVersion: string | undefined;
    excludedVersions: string | undefined;
    browserIcons: string[] = [];

    constructor(
        translate: ITranslate,
        tsLocaleHelper: any,
        environmentService: any,
        displayTabletAsDesktop: boolean,
        private _state: BrowserNotSupportedState
    ) {
        this._translate = translate;
        this.dir = tsLocaleHelper.isRTL() ? 'rtl' : 'ltr';
        this._environmentService = environmentService;
        this._displayTabletAsDesktop = displayTabletAsDesktop;

        if (this.userName) {
            this._initBrowsers();
        }
    }

    get translate(): ITranslate {
        return this._translate;
    }

    get browserInfo(): BrowserInfo | null {
        return this._state.browserInfo;
    }

    get userName(): string {
        return this._state.userName;
    }

    get browserMajor(): string {
        return this._environmentService.browser().major;
    }

    private _initBrowsers(): void {
        if (!this.browserInfo) return;

        const browsers =
            this.browserInfo.browsers[this._environmentService.deviceCategory(this._displayTabletAsDesktop)] || {};

        this.enabledBrowsersArr = extractBrowsers(browsers);
        this.enabledBrowsers = this.enabledBrowsersArr.join(', ');

        const browserName = camelCase(this.browserInfo.browserName);
        this.minVersion = get(browsers, `${browserName}MinVersion`);

        const excludedVersions = get(browsers, `${browserName}ExcludedVersions`);
        this.excludedVersions = excludedVersions ? excludedVersions.join(', ') : undefined;

        this.browserIcons = this.browserInfo.isSupportedBrowser
            ? [this.browserInfo.browserName]
            : this.enabledBrowsersArr;
    }
}
